import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/BaseUrl"
import httpRequest from "../../utils/httpsRequest";

export const fetchOverview = createAsyncThunk(
  "overview/fetchOverview",
  async () => {
    return httpRequest(`${BASE_URL}/ManageUser/DashboardOverview`);
  }
)

const overviewSlice = createSlice({
  name: 'overview',
  initialState: {
    overview: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOverview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOverview.fulfilled, (state, action) => {
        state.loading = false;
        state.overview = action.payload;
      })
      .addCase(fetchOverview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default overviewSlice.reducer;

